import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseSettlePoolController';
export default {
    /**
     * 结清案件池
     */
    getCaseSettlePoolPageList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCasePoolPageList',
        type: requestType.Get
    },
};
